export const STATUS_STYLES: Record<string, {
  chipBg: string;
  chipColor: string;
  selectBorder: string;
}> = {
  prospect: {
    chipBg: "#e8f0fe",
    chipColor: "#1a73e8",
    selectBorder: "#ef7d00",
  },
  onboarding: {
    chipBg: "#fff3e0",
    chipColor: "#e65100",
    selectBorder: "#ef7d00",
  },
  dormant: {
    chipBg: "#e8f3ea",
    chipColor: "#616161",
    selectBorder: "#ef7d00",
  },
  "current client": {
    chipBg: "#e8f5e9",
    chipColor: "#2e7d32",
    selectBorder: "#ef7d00",
  },
  archived: {
    chipBg: "#fce8e6",
    chipColor: "#c5221f",
    selectBorder: "#ef7d00",
  },
  default: {
    chipBg: "#eeeeee",
    chipColor: "#616161",
    selectBorder: "#ef7d00",
  }
};